import initSimpleBar from './components/SimpleBar';

jQuery(function() {
  initSimpleBar();
});

// variant filters
let filterRow = document.querySelectorAll('.filter-row');
let filtersApplied = {
  onlyInStock: false,
};

const renderFilterRow = () => {
  filterRow.forEach((row) => {
    let isVisible = true;
    const filters = JSON.parse(row.dataset.filters);
    const { stock } = row.dataset;
    Object.keys(filters).forEach((filterName) => {
      Object.keys(filtersApplied).forEach((filterAppliedName) => {
        if (filterName === filterAppliedName) {
          const appliedFilter = filtersApplied[filterName];
          const rowFilter = filters[filterName];
          if (appliedFilter && appliedFilter !== rowFilter.value) {
            isVisible = false;
          }
        }
      });
    });
    if (filtersApplied.onlyInStock && `${stock}` === '0') {
      isVisible = false;
    }
    if (isVisible) {
      row.classList.remove('d-none');
    } else {
      row.classList.add('d-none');
    }
  });
};

document.querySelectorAll('.select-variant-attribute').forEach((selectElement) => {
  selectElement.addEventListener('change', () => {
    const { filterName } = selectElement.dataset;
    filtersApplied[filterName] = selectElement.value;
    renderFilterRow();
  });
});

document.querySelectorAll('.checkbox-variant-stock').forEach((checkboxElement) => {
  checkboxElement.addEventListener('change', () => {
    filtersApplied.onlyInStock = checkboxElement.checked;
    renderFilterRow();
  });
});

// variant modal
const modalVariant = document.getElementById('modal-variant');
modalVariant.addEventListener('show.bs.modal', event => {
  const button = event.relatedTarget;
  const variantUrl = button.getAttribute('data-variant-url');
  const data = JSON.parse(button.getAttribute('data-modal'));
  const downloads = JSON.parse(button.getAttribute('data-variant-downloads'));
  const $downloads = modalVariant.querySelector('.links');
  const table = modalVariant.querySelector('.table');
  table.innerHTML = '';
  const modalTitle = modalVariant.querySelector('.modal-title');
  modalTitle.innerHTML = button.getAttribute('data-id');
  const ths = JSON.parse(document.querySelector('table[data-modal]').getAttribute('data-modal'));
  const p = modalVariant.querySelector('.product-title');
  const $deeplink = modalVariant.querySelector('button.deeplink');

  // stock logic
  const $stock = modalVariant.querySelector('.stock');
  const stock = parseInt(button.getAttribute('data-stock'));
  const unlimited = parseInt(button.getAttribute('data-unlimited'));
  $stock.classList.remove('bg-warning', 'bg-success', 'bg-danger');
  if (stock > 100 || unlimited) {
    $stock.classList.add('bg-success');
  } else if (stock > 0) {
    $stock.classList.add('bg-warning');
  } else {
    $stock.classList.add('bg-danger');
  }

  // attributes table
  for (const attr in ths) {
    if (attr === 'DAT_VisibleWebshop_TXT' || attr === 'DAT_VisibleInCraft_TXT') {
      continue;
    }
    if (attr === 'DAT_Product_TXT') {
      p.innerHTML = data[attr].value;
      continue;
    }
    if (ths[attr] !== null) {
      let tr = document.createElement('tr');
      let th = document.createElement('th');
      th.innerHTML = ths[attr].attributeTitle;
      let td = document.createElement('td');
      td.innerHTML = data[attr]?.value ?? '';
      tr.append(th);
      tr.append(td);
      table.append(tr);
    }
  }

  // deeplink copy logic
  history.replaceState({ productUrl: button.getAttribute('data-product-url') }, '', variantUrl);
  $deeplink.addEventListener('click', function () {
    window.navigator.clipboard.writeText(variantUrl);
    $deeplink.querySelector('.text').innerHTML = $deeplink.getAttribute('data-text-copied')
  });
  $deeplink.addEventListener('mouseout', function () {
    $deeplink.querySelector('.text').innerHTML = $deeplink.getAttribute('data-text-initial');
  })

  // download links logic
  $downloads.querySelectorAll('li:not(.deeplink)').forEach(e => e.remove());
  const $downloadTmpl = document.getElementById('download-btn-tmpl')
  downloads.forEach(function (asset){
    let li = document.createElement('li');
    li.classList.add('list-inline-item')
    let link = document.createElement('a');
    link.classList.add('btn', 'btn-link', 'p-0');
    link.target = '_blank';
    link.download = '';
    link.href = asset.url;
    link.innerHTML = $downloadTmpl.innerHTML + asset.title;
    li.append(link);
    $downloads.append(li);
  })
});

modalVariant.addEventListener('hide.bs.modal', event => {
  const prevState = history.state.productUrl;
  history.replaceState(null, '', prevState);
});

if (new URLSearchParams(window.location.search).has('variant')) {
  const variants = document.getElementById('variations');
  const variant = new URLSearchParams(window.location.search).get('variant');
  const trigger = document.getElementById('variant' + variant);
  if (trigger && variants) {
    variants.scrollIntoView({ behavior: "instant", block: "center"});
    trigger.click();
  }
}

// documents lang switcher
const documentationLanguageElement = document.getElementById('documentation-language');
documentationLanguageElement.addEventListener('change', function (e) {
  document.querySelectorAll('.download-list li').forEach((row) => {
    const lang = row.dataset.lang.split(/[,;\n\r|]/).map(e=>e.trim());
    lang.includes(e.target.value) ? row.classList.remove('d-none') : row.classList.add('d-none');
  });
});
documentationLanguageElement.dispatchEvent(new Event('change'));
